import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-login-content" }
const _hoisted_2 = { class: "admin-login-box" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "account" }
const _hoisted_5 = { class: "password" }
const _hoisted_6 = { class: "submit" }

import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { BaseResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { ref, Ref } from 'vue';

//账号

export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const account: Ref<string> = ref('')

//密码
const password: Ref<string> = ref('')

const onLogin: Action = async () => {
    const response: BaseResponse = await Api.instance.adminLogin({
        account: account.value,
        password: password.value
    })

    UtilMethods.showMessageToast(response)

    if(response.code === ResponseCode.OK) {
        router.replace({
            name: 'adminIndex'
        })
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, " 后台管理员登录 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", null, "账号", -1)),
          _createVNode(_component_el_input, {
            modelValue: account.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((account).value = $event)),
            placeholder: "请输入账号"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "密码", -1)),
          _createVNode(_component_el_input, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            placeholder: "请输入密码",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            round: "",
            size: "large",
            class: "w-full",
            onClick: onLogin
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("登录")
            ])),
            _: 1,
            __: [4]
          })
        ])
      ])
    ])
  ]))
}
}

})